import "./base.js";
import "./mixins/conditional_visibility.js";
import "../../../admin/form/field_counter.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.Field = class Field extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.renderFieldCounter = this.renderFieldCounter.bind(this);
  }

  render() {
    super.render(...arguments);

    this.renderFieldCounter();

    return this;
  }

  renderFieldCounter() {
    const inputWithCounter = this.$el.find("[data-counter]");
    if (inputWithCounter.length) {
      return window.Form.FieldCounter.decorate(inputWithCounter, { message: false });
    }
  }
};
AppointmentBooking.Wizard.Views.Field.prototype.className = "field";
AppointmentBooking.Wizard.Views.Field.prototype.template = false;
